import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { PlanosContas } from 'src/app/core/planos-contas';
import { TipoReuniao } from '../../core/tipo-reuniao';
import { TiposReuniaoService } from '../../services/tipos-reuniao/tipo-reuniao.service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'tipo-reuniao',
  templateUrl: './tipo-reuniao.component.html',
  styleUrls: ['./tipo-reuniao.component.css']
})
export class TipoReuniaoComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  listaTiposReunioes: TipoReuniao[];
  mostrarTabela: boolean = false;
  tipoReuniao: TipoReuniao = new TipoReuniao();
  msg: string;

  displayedColumns: string[] = ['descricao', 'acoes'];
  dataSource: MatTableDataSource<TipoReuniao> = new MatTableDataSource();
  
  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();
  planosContas: PlanosContas[];

  constructor(
    private tipoReuniaoService: TiposReuniaoService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.dataSource.paginator = this.paginator;
    this.getAll();
  }


  limpar() {
    this.mostrarTabela = false;
    this.tipoReuniao = new TipoReuniao()
    this.dataSource.data = [];
  }

  consultar() {
    if (this.tipoReuniao.id) {
      this.tipoReuniaoService.getById(this.tipoReuniao.id).subscribe((tipoReuniao: TipoReuniao) => {
        if (!tipoReuniao) {
          this.mostrarTabela = false
          this.msg = "Nenhum registro para a pesquisa selecionada"
        } else {
          this.dataSource.data = [tipoReuniao];
          this.mostrarTabela = true;
        }
      },
        (retorno) => {
          this.mostrarTabela = false
          this.msg = retorno.error.mensagem
        }
      )
    } else {
      this.getAll();
    }

  }


  atualizar(tipoReuniao: TipoReuniao) {
    console.log('ti = ', tipoReuniao);
    this.router.navigate(['/tiposreunioes/cadastrar'], { queryParams: { id: tipoReuniao.id } });
  }

  deletar(tipoReuniao: TipoReuniao) {
    this.chamaCaixaDialogo(tipoReuniao);
  }

  chamaCaixaDialogo(tipoReuniao: TipoReuniao) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir ?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.tipoReuniaoService.excluir(tipoReuniao.id).subscribe(() => {
          this.tipoReuniao.id = null;
          this.consultar();
        })

      } else {
        dialogRef.close();
      }
    }
    );
  }

  getAll() {
    this.tipoReuniaoService.getAll().subscribe((listaTiposReunioes: TipoReuniao[]) => {
      this.listaTiposReunioes = listaTiposReunioes;
      this.dataSource.data = listaTiposReunioes ? listaTiposReunioes : [];
      this.verificaMostrarTabela(listaTiposReunioes);
    })
  }

  verificaMostrarTabela(listaTiposReunioes: TipoReuniao[]) {
    if (!listaTiposReunioes || listaTiposReunioes.length == 0) {
      this.mostrarTabela = false;
      this.msg = "Nenhum tipo de reunião cadastrado."
    } else {
      this.mostrarTabela = true;
    }
  }

}
